import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { optionCarousel } from 'src/app/utility/carousel.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-logos',
  templateUrl: './sample-logos.component.html',
  styleUrls: ['./sample-logos.component.scss']
})
export class SampleLogosComponent implements OnInit {

  @Input() block: any;
  @Input() viewCarousel: any;
  private domainWebsite = environment.urlApi;
  public customOptionsOwl: OwlOptions = {} as OwlOptions;

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.customOptionsOwl = optionCarousel('blocco_logo_carousel');
  }

  public isCarousel(): boolean {
    let isCarousel: boolean;
    if (!this.viewCarousel || (this.viewCarousel && this.viewCarousel === 'no')) {
      isCarousel = false;
    } else {
      isCarousel = true;
    }
    return isCarousel;
  }

  public retriveLink(link: string): any {
    const linkTemp: string = this.nodeService.retriveLinkTagA(link, 'a').link;
    const isLinkEsternal: boolean = this.nodeService.verifyLinkExternal(linkTemp);
    return {
      isExternal: isLinkEsternal,
      link: linkTemp
    }
  }

  public retriveImg(dataImage: string): any {
    const src: string = this.domainWebsite + this.nodeService.retrieveImage(dataImage, 'src');
    const alt: string = this.nodeService.retrieveImage(dataImage, 'alt');
    return {
      imageSrc: src,
      imageAlt: alt
    }
  }

}
